// extracted by mini-css-extract-plugin
export default {"BubbleLink":"vXY5LAHF+V1gBd6FzDdKfg=="};